(() => {
  const updateValue = (elem) => {
    const parent = elem.closest('.swinger-compare');

    parent.style.setProperty('--swinger-compare-value', elem.value);
  };

  window.swinger.observer.initialize('.swinger-compare__handle', updateValue, false);

  window.swinger.observer.initialize('.swinger-compare video', (elem) => {
    window.swinger.resourceLoader.module(`${window.swinger.config.assetsBase}/media-group/media-group.js?v=${window.swinger.config.version}`);

    elem.setAttribute('group', 'swinger-compare-group');
  }, false);

  window.swinger.eventHub.register('input', '.swinger-compare__handle', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    updateValue(elem);
  });

  document.addEventListener('fullscreenchange', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const parent = elem.closest('.swinger-compare');

    if (!parent) {
      return;
    }

    if (!document.fullscreenElement) {
      parent.requestFullscreen({
        navigationUI: 'hide',
      }).catch((err) => {
        console.error(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }

    e.preventDefault();
  }, true);
})();
